export default __webpack_public_path__ + "static/media/pattern.db45f085.jpg";